import GoogleAnalyticsEvent from "../../../../../../../shared/src/ranj/analytics/GoogleAnalyticsEvent";
import GoogleAnalyticsStrings from "../../../../../../../shared/src/ranj/analytics/GoogleAnalyticsStrings";
import AbstractCommand from "../../../../../../../shared/src/ranj/app/core/AbstractCommand";
import GameModel from "../../../core/model/GameModel";
import TrackingController from "../../../tracking/controller/TrackingController";
import PlaySessionModel from "../../playsession/PlaySessionModel";
import ScenarioPlayerEvent from "../../scenario/ScenarioPlayerEvent";
import CollaborationDialogPlayer from "../CollaborationDialogPlayer";
import DialogPlayerRegisterEvent from "./DialogPlayerRegisterEvent";


export default class PlayDialogCommand extends AbstractCommand {

    /**
     * 
     * @param {*} dispatcher 
     * @param {*} assetLibrary 
     * @param {*} variableManager 
     * @param {*} dialogFactory 
     * @param {CollaborationDialogPlayer} dialogPlayer 
     * @param {GameModel} gameModel 
     * @param {TrackingController} trackingController 
     * @param {PlaySessionModel} playSessionModel
     */
    constructor(dispatcher, assetLibrary, variableManager, dialogFactory, dialogPlayer, gameModel, trackingController, playSessionModel) {
        super(dispatcher);
        this._assetLibrary = assetLibrary;
        this._variableManager = variableManager;
        this._dialogFactory = dialogFactory;

        this._dialogPlayer = dialogPlayer;
        this._gameModel = gameModel;
        this._trackingController = trackingController;
        this._playSessionModel = playSessionModel;

        this._handleContentCompletedBound = this._handleContentCompleted.bind(this);
    }

    execute(event) {
        const { content, contentPlayer, dialogMemento } = event.params.data;
        const dialogID = content.getDialogID();

        if (this._gameModel.skipToDialogId) {
            if (dialogID !== this._gameModel.skipToDialogId) {
                contentPlayer.contentCompleted(content);
                return;
            } else {
                this._gameModel.skipToDialogId = null;//only once
            }
        }

        this.startDialog(content, contentPlayer, dialogMemento);

    }

    startDialog(content, contentPlayer, dialogMemento) {

        const dialogID = content.getDialogID();
        this._dialogID = dialogID;
        this._scenarioID = this._playSessionModel.getCurrentScenarioSession().getScenarioID();

        this._trackingController.trackDialogStart(this._scenarioID, dialogID);

        this._dialogPlayer.setContentPlayer(contentPlayer);
        this._dialogPlayer.setContent(content);

        this._gameModel.currentDialogPlayer = this._dialogPlayer;

        const dialog = this._dialogFactory.getDialog(dialogID);
        this._dialogPlayer.setDialog(dialog);

        var dprEvent = new DialogPlayerRegisterEvent(DialogPlayerRegisterEvent.REGISTER, this._dialogPlayer, dialogMemento);
        this._dispatcher.dispatch(dprEvent.type, dprEvent);

        if (dialogMemento) {
            this._dialogPlayer.loadMemento(dialogMemento);
        }

        //GoogleAnalytics: set dialog id as value of custom dimension DIALOG so all events during dialog are attributed accordingly
        //	NB: unset again when dialog closes/completes
        this._dispatcher.dispatch(GoogleAnalyticsEvent.DIMENSION, { index: GoogleAnalyticsStrings.DIALOG, value: dialogID });

        this._dispatcher.addEventListener(ScenarioPlayerEvent.CONTENT_COMPLETED, this._handleContentCompletedBound, this);

        this._startTime = Date.now();
    }

    _handleContentCompleted({ params }) {
        if (params.data.content === this._dialogPlayer.getContent()) {

            if (this._gameModel.currentDialogPlayer == this._dialogPlayer) {
                this._gameModel.currentDialogPlayer = null;
            }

            this._trackingController.trackDialogEnd(this._scenarioID, this._dialogID);
            // This dialog is complete: move on!
            this._dispatcher.removeEventListener(ScenarioPlayerEvent.CONTENT_COMPLETED, this._handleContentCompletedBound);

            var dprEvent = new DialogPlayerRegisterEvent(DialogPlayerRegisterEvent.DEREGISTER, this._dialogPlayer);
            this._dispatcher.dispatch(dprEvent.type, dprEvent);

            //var duration = Date.now()-this._startTime;
            //GoogleAnalytics: unset dialog id as value of custom dimension DIALOG 
            this._dispatcher.dispatch(GoogleAnalyticsEvent.DIMENSION, { index: GoogleAnalyticsStrings.DIALOG, value: null });

            // Close the content.
            this.destroy();
        }
    }

    destroy() {
        this._dialogPlayer.destroy();
    }
}